import { useHistory } from "react-router-dom";
import { useAppContext } from "../../../../context/AuthContext";
import LectureDto from "../../../../interfaces/lecture/LectureDto";
import MyLecturesService, { MyLecturesServiceType } from "../my-lectures/MyLecturesService";
import LiveLectureTabs from "../live-lecture/LiveLectureTabs";
import { Grid, Typography } from "@mui/material";
import SelectCustom from "../../../shared/select-custom/SelectCustom";
import LiveLectureQuestion from "../live-lecture/tab-question/LiveLectureQuestion";
import React, { useState } from "react";
import EnumSortItem from "../../../../utils/enum/EnumSortItem";
import { Course, Lecture, SignalSocket } from "../../../../controller";
import { wsEvents } from "../../../../constants";
import EnumSignal from "../../../../utils/enum/EnumSignal";
import { isLectureFuture, isLectureLive, SIGNAL_REMOVED_FROM_CLASS, useEffectOnce } from "../../../../utils/Utils";
import Routes from "../../../../utils/Routes";
import MessageType from "../../../../utils/MessageType";
import EnumTabs from "../../../../utils/enum/EnumTabs";

const optionsSortBy = [
    { id: EnumSortItem.TIME, label: "Most Recent" },
    { id: EnumSortItem.VOTE, label: "# of Thumbs Up" },
    { id: EnumSortItem.NUM_OF_ANSWERS, label: "# of Responses" },
];

export default function OpenForum() {
    const history = useHistory();
    const { updateSelectedLecture, showMessage, updateSelectedCourse, selectedCourse, selectedLecture } = useAppContext();
    const [loading, setLoading] = useState<boolean>(false);
    const [sortBy, setSortBy] = useState<number>(optionsSortBy[0].id);
    const [lecture, setLecture] = useState<LectureDto | undefined>(undefined);
    const [currentSlide, setCurrentSlide] = useState<number>(0);

    const handleChangeSelect = (e: any) => setSortBy(e.target.value);

    useEffectOnce(() => {
        getLectures();
        SignalSocket.on(wsEvents.recv.SIGNAL, handleSignal);
        return () => {
            SignalSocket.off(wsEvents.recv.SIGNAL, handleSignal);
        };
    });

    const handleSignal = (signal: string) => {
        const updateLectureSignals: string[] = [EnumSignal.LECTURE_STARTED, EnumSignal.LECTURE_ENDED, EnumSignal.LECTURE_UPDATED];
        if (updateLectureSignals.includes(signal)) {
            getLectures();
        }
        if (SIGNAL_REMOVED_FROM_CLASS.includes(signal)) {
            history.push(Routes.OLD_OR_NEW_STUDENT);
            showMessage("You have been removed from meeting.", MessageType.ERROR);
        }
    };
    const getLectures = () => {
        setLoading(true);

        Lecture.getCourseLectures(selectedCourse.id)
            .then(async ({ data }: any) => {
                if (data?.message) {

                    if (Boolean(!selectedCourse?.name)) {
                        const course = await Course.getCourse(selectedCourse.id);
                        updateSelectedCourse(course.data.data);
                    }
                    if (Boolean(!selectedLecture)) {
                        updateSelectedLecture(selectedLecture);
                    }

                    const openForumLecture = data.data.find((l: LectureDto) => l.isOpenForumLecture);
                    setLecture(openForumLecture);

                    console.log("openForumLecture", openForumLecture);
                } else {
                    console.error(data);
                }
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    return (

        <Grid container justifyContent="center" alignItems="center" columnSpacing={2} >
            <Grid item xs={12}>
                <Grid container justifyContent="center" alignItems="stretch" flexDirection="column">
                    {loading ? (
                        <Typography variant="h6">Open forum loading...</Typography>
                    ) : !lecture ? (
                        <Typography align="center" variant="h6">No open forum found</Typography>
                    ) : (
                        <>
                            <Grid container item xs={12} justifyContent="center" alignItems="center" spacing={2} mb={2}>

                                <Grid item alignItems="center" flexDirection="row" display="flex" justifyContent="space-around" xs={10} >
                                    <Grid xs={10} display="flex" justifyContent="center" paddingLeft={6}>
                                        <Typography variant="h6">Open Forum</Typography>
                                    </Grid>
                                    <Grid xs={2}>
                                        <SelectCustom title="Sort by" value={sortBy} handleChange={handleChangeSelect} options={optionsSortBy} />
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid>
                                <LiveLectureQuestion lecture={lecture} currentSlide={currentSlide} sortBy={sortBy} tab={EnumTabs.Q_A} />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </Grid>

    );
}